import eveningScent from "../../../../assets/cards/gardener/game/starlight.jpg?url";
import freshGrass from "../../../../assets/cards/gardener/game/sprout-dream.jpg?url";
import mirrorPassenger from "../../../../assets/cards/station/fullbleed-v1/game/mirror-passenger.jpg?url";
import sleepingMoss from "../../../../assets/cards/gardener/game/soil-blanket.jpg?url";
import loopingPath from "../../../../assets/story/chapters/chapter-01/cards/looping-path-v1.png?url";
import redBall from "../../../../assets/story/chapters/chapter-01/cards/red-ball-v1.png?url";
import distantRoar from "../../../../assets/story/chapters/chapter-02/cards/distant-roar-v1.png?url";
import firstAidKit from "../../../../assets/story/chapters/chapter-02/cards/first-aid-kit-v1.png?url";
import flyingDragon from "../../../../assets/story/chapters/chapter-02/cards/flying-dragon-v1.png?url";
import heroBoots from "../../../../assets/story/chapters/chapter-02/cards/hero-boots-v1.png?url";
import heroCloak from "../../../../assets/story/chapters/chapter-02/cards/hero-cloak-v1.png?url";
import honeyRation from "../../../../assets/story/chapters/chapter-02/cards/honey-ration-v1.png?url";
import injuredDragon from "../../../../assets/story/chapters/chapter-02/cards/injured-dragon-v1.png?url";
import returnMap from "../../../../assets/story/chapters/chapter-02/cards/return-map-v1.png?url";
import sturdyRope from "../../../../assets/story/chapters/chapter-02/cards/sturdy-rope-v1.png?url";
import crowdedPlatform from "../../../../assets/cards/station/fullbleed-v1/game/crowded-platform.jpg?url";
import lostPair from "../../../../assets/cards/station/fullbleed-v1/game/lost-pair.jpg?url";
import mirrorGate from "../../../../assets/cards/station/fullbleed-v1/game/mirror-gate.jpg?url";
import stationFog from "../../../../assets/cards/station/fullbleed-v1/game/station-fog.jpg?url";

const baseCardArt: Readonly<Record<string, string>> = {
  mirror_passenger: mirrorPassenger,
  night_flower: eveningScent,
  red_ball: redBall,
  sleeping_moss: sleepingMoss,
  story_evening_scent: eveningScent,
  story_fresh_grass: freshGrass,
  story_looping_path: loopingPath,
  story_distant_roar: distantRoar,
  story_first_aid: firstAidKit,
  story_flying_dragon: flyingDragon,
  story_hero_boots: heroBoots,
  story_hero_cloak: heroCloak,
  story_honey_ration: honeyRation,
  story_injured_dragon: injuredDragon,
  story_return_map: returnMap,
  story_sturdy_rope: sturdyRope,
  greenhouse_sprout: freshGrass,
  lost_pair: lostPair,
  mirror_gate_object: mirrorGate,
  station_fog: stationFog,
  crowded_platform: crowdedPlatform,
};

const suppliedFreeBattleArt = import.meta.glob(
  "../../../../assets/cards/free-battle-folk-tarot-v2/*.png",
  { eager: true, query: "?url", import: "default" },
) as Record<string, string>;

const suppliedBasicArt = import.meta.glob(
  "../../../../assets/cards/basic-folk-tarot-v2/*.png",
  { eager: true, query: "?url", import: "default" },
) as Record<string, string>;

function indexPngArt(modules: Readonly<Record<string, string>>): Readonly<Record<string, string>> {
  return Object.freeze(Object.fromEntries(Object.entries(modules).flatMap(([path, url]) => {
    const fileName = path.split(/[\\/]/).at(-1) ?? "";
    const cardId = fileName.replace(/\.png$/i, "");
    return cardId ? [[cardId, url]] : [];
  })));
}

const basicTarotArt = indexPngArt(suppliedBasicArt);
const freeBattleTarotArt = indexPngArt(suppliedFreeBattleArt);

const cardArt: Readonly<Record<string, string>> = Object.freeze({
  ...baseCardArt,
  ...basicTarotArt,
  ...freeBattleTarotArt,
});

export function getCardArtUrl(cardId: string): string {
  return cardArt[cardId] ?? "";
}
